var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {},
    [
      _c("modal-tooltip", {
        attrs: {
          show: _vm.showModal,
          "text-a": _vm.textA,
          "text-b": _vm.textB,
          title: _vm.title
        },
        on: {
          close: function($event) {
            _vm.showModal = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "a",
        { staticStyle: { "text-decoration": "none" }, attrs: { href: "#" } },
        [
          _c("span", {
            staticClass: "icon-info_sign",
            staticStyle: {
              color: "black",
              "font-size": "Small",
              "margin-left": "4px"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.showModal = true
              }
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-327e9cde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-327e9cde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoIconWithExplanationModal.vue
// module id = null
// module chunks = 